import React from 'react';

import { Confirm } from 'components/ui/modal';
import { connect } from 'containers/store';
import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteMoodRequest } from 'generated/mos/org/getty/audiomanagement'

import { pick } from 'helpers/core';
import { Status } from 'helpers/status'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';


type ConnectedProps = {
  moodDelete: GettyStore['getty']['moodDelete'];
};
type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteMoodRequest' | 'gettyDeleteMoodReset'> &
  Pick<SharedActionCreators, 'toastNotification'>;
type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  onCancel: () => void;
  moodRef?: DeleteMoodRequest.Entity['moodRef'];
};

type Props = ConnectedProps & ActionProps & DirectProps;

const MoodDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    onCancel,
    moodRef,
    moodDelete,
    toastNotification,
    gettyDeleteMoodRequest,
    gettyDeleteMoodReset,
  } = props

  const payload: DeleteMoodRequest.Entity ={
    ...DeleteMoodRequest.defaults,
    moodRef: moodRef
  }
  const onConfirmDelete = () => {
    gettyDeleteMoodRequest(payload)
    historyPush(`/project/${projectId}/moods`)
  }

  if (moodDelete.status === Status.Failed) {
    toastNotification({
      type: 'error',
      text: 'Could not delete mood journey',
    });
    gettyDeleteMoodReset();
  }

  return (
    <Confirm
      title="Delete mood journey?"
      onClose={onCancel}
      message={`Are you sure you want to permanently delete this mood journey?`}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const MoodDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
    (store) => pick(store.getty, 'moodDelete'),{
      ...pick(actionCreators, 'gettyDeleteMoodRequest', 'gettyDeleteMoodReset'),
      ...pick(sharedActionCreators, 'toastNotification')
    }
)(MoodDeleteView);
